import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByobBlueprintSummaryComponent } from './byob-blueprint-summary.component';
import { ByobBlueprintSummarRoutingModule } from './byob-blueprint-summar-routing.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CapabilityCardModule } from '../../../components/capability-card/capability-card.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    ByobBlueprintSummaryComponent
  ],
  imports: [
    CommonModule,
    ByobBlueprintSummarRoutingModule,
    CommonModule,
    BreadcrumbModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    MatProgressBarModule,
    CapabilityCardModule,
    MatProgressSpinnerModule
  ]
})
export class ByobBlueprintSummaryModule { }
